import { StyledGraphMain } from '../ResourceAllocationOverview.style';
import Graph from './Graph/Graph';
import { StyledFteAllocation } from './FteAllocation.style';
import FteHeader from './FteHeader/FteHeader';
import useFteAllocation from './useFteAllocation/useFteAllocation';
import Loader from './Loader';

const FteAllocation = () => {
  const { data, isLoading, resourceType, setResourceType } = useFteAllocation();

  return (
    <StyledFteAllocation data-cy='fte-allocation'>
      <FteHeader
        resourceType={resourceType}
        setResourceType={setResourceType}
      />
      <StyledGraphMain>
        {isLoading ? (
          <Loader />
        ) : (
          <Graph data={data} resourceType={resourceType} />
        )}
      </StyledGraphMain>
    </StyledFteAllocation>
  );
};

export default FteAllocation;
